module.exports = __webpack_public_path__ + "media/promo/courses/images/leafm-d1499725f34a2c132e38e423dfb8799d.png";